export default __webpack_public_path__ + "static/media/rocket_anim_132.4b13afbe.png";